import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import styles from './Popup.module.css';

const Popup = ({ isOpen, onClose }) => {
  const [rendered, setRendered] = useState(isOpen);
  const overlayRef = useRef(null);
  const popupRef = useRef(null);
  const timelineRef = useRef(null);
  const isClosingRef = useRef(false);

  const animateIn = () => {
    timelineRef.current?.kill();
    gsap.set([overlayRef.current, popupRef.current], { opacity: 0 });
    timelineRef.current = gsap.timeline();
    timelineRef.current
      .to(overlayRef.current, { opacity: 1, duration: 0.25 }, 0)
      .fromTo(
        popupRef.current,
        { y: 30, opacity: 0, scale: 0.95 },
        { y: 0, opacity: 1, scale: 1, duration: 0.4, ease: 'back.out(1.3)' },
        0
      );
  };

  const animateOut = (callback) => {
    if (isClosingRef.current) return;
    isClosingRef.current = true;
    timelineRef.current?.kill();
    timelineRef.current = gsap.timeline({ onComplete: () => {
      isClosingRef.current = false;
      setRendered(false);
      callback?.();
    }});

    timelineRef.current
      .to(popupRef.current, { y: 20, opacity: 0, scale: 0.95, duration: 0.2, ease: 'power1.in' }, 0)
      .to(overlayRef.current, { opacity: 0, duration: 0.2 }, 0);
  };

  useEffect(() => {
    if (isOpen) {
      setRendered(true);
      return;
    }
    if (rendered) {
      animateOut();
    }
  }, [isOpen, rendered]);

  useEffect(() => {
    if (rendered && isOpen) {
      animateIn();
    }
  }, [rendered, isOpen]);

  const handleClose = () => {
    if (!rendered || isClosingRef.current) return;
    animateOut(onClose);
  };

  if (!rendered) return null;

  return (
    <div className={styles.overlay} ref={overlayRef} onClick={handleClose}>
      <div className={styles.popup} ref={popupRef} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeBtn} onClick={handleClose}>×</button>
        <div className={styles.content}>
          <img src="/images/luminia-logo.svg" alt="Lumin'IA Logo" className={styles.logo} />
          <h2>Accès requis</h2>
          <p>Veuillez contacter l'équipe Lumin'IA pour avoir accès à cette fonctionnalité.</p>
          <a href="mailto:luminia.madagascar@gmail.com" className={styles.email}>
            luminia.madagascar@gmail.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default Popup;